// Client-side validation. Limits mirror firestore.rules so a request that passes
// here is never rejected by the backend.

export const LIMITS = {
  name: 60,
  email: 254,
  place: 80,
  instagram: 30,
  tags: 5,
};

export const TAGS = ['Bitter', 'Balanced', 'Sweet', 'Spicy', 'Fruity', 'Boozy', 'Fancy Ice', 'Vibes'];

export const cleanText = (value, max) => (value || '').replace(/\s+/g, ' ').trim().slice(0, max);

export const normalizeEmail = (email) => (email || '').trim().toLowerCase();

// The normalized email doubles as the Firestore document id, so it also can't contain "/"
// or look like a reserved id (__name__).
export const isValidEmail = (email) =>
  email.length <= LIMITS.email && /^[^\s@/]+@[^\s@/]+\.[^\s@/]+$/.test(email) && !/^__.*__$/.test(email);

/** "@Drink.Groni " -> "drink.groni". Returns '' for empty input and null for an invalid handle. */
export function normalizeInstagram(handle) {
  const value = (handle || '').trim().replace(/^@+/, '').toLowerCase();
  if (!value) return '';
  return /^[a-z0-9._]{1,30}$/.test(value) ? value : null;
}

/** Round to one decimal place and clamp to 0–10. */
export function clampRating(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.min(10, Math.max(0, Math.round(n * 10) / 10));
}

export function validateWaitlist({ firstName, lastName, email }) {
  const errors = {};
  if (!cleanText(firstName, LIMITS.name)) errors.firstName = 'Please add your first name';
  if (!cleanText(lastName, LIMITS.name)) errors.lastName = 'Please add your last name';
  if (!isValidEmail(normalizeEmail(email))) errors.email = 'Please enter a valid email address';
  return errors;
}

export function validateUpload({ firstName, lastName, location, venue, instagram, rating }, file) {
  const errors = {};
  if (!file) errors.image = 'Add a photo of your groni';
  if (!cleanText(firstName, LIMITS.name)) errors.firstName = 'Please add your first name';
  if (!cleanText(lastName, LIMITS.name)) errors.lastName = 'Please add your last name';
  if (!cleanText(venue, LIMITS.place)) errors.venue = 'Where did you drink it?';
  if (!cleanText(location, LIMITS.place)) errors.location = 'Which town or city?';
  if (normalizeInstagram(instagram) === null) errors.instagram = 'Letters, numbers, dots and underscores only';
  if (rating === null || rating === undefined) errors.rating = 'Give it a score';
  return errors;
}
